
/*
 |--------------------------------------------------------------------------
 | Laravel Spark Components
 |--------------------------------------------------------------------------
 |
 | Here we will load the Spark components which makes up the core client
 | application. This is also a convenient spot for you to load all of
 | your components that you write while building your applications.
 */

require('./../spark-components/bootstrap');
require('./shared/AppHeader');
const SettingsSidebar = require("./shared/SettingsSidebar.vue");

// Platform
Vue.component('PlatformSearch', require('./pages/PlatformSearch.vue'));
Vue.component('PlatformHazardType', require('./pages/PlatformHazardType.vue'));

// Pages
Vue.component('CatUxoPageProfile', require('./pages/settings/Profile'));
Vue.component('CatUxoPageBilling', require('./pages/settings/Billing'));
Vue.component('CatUxoPageContributions', require('./pages/settings/Contributions'));
Vue.component('CatUxoPageAdvertisement', require('./pages/settings/Advertisement'));
Vue.component('CatUxoPageUxoTypes', require('./pages/UxoTypes'));
Vue.component('CatUxoPageIncidents', require('./pages/Incidents'));
Vue.component('CatUxoPageTerroristGroups', require('./pages/TerroristGroups'));
Vue.component('CatUxoPageUxoType', require('./pages/UxoType'));
Vue.component('CatUxoPageSearch', require('./pages/Search'));
Vue.component('CatUxoPageSupporters', require('./pages/Supporters'));
Vue.component('CatUxoPageSupporter', require('./pages/Supporter'));
Vue.component('CatUxoSettingsSidebar', require('./shared/SettingsSidebar.vue'));




// Forms
Vue.component('CatUxoFormContribute', require('./forms/Contribute'));
Vue.component('CatUxoFormRegister', require('./forms/Register'));
Vue.component('CatUxoFormPasswordsEmail', require('./forms/passwords/Email'));
Vue.component('CatUxoFormPasswordsReset', require('./forms/passwords/Reset'));
Vue.component('CatUxoFormAdSignUp', require('./forms/AdSignUp'));
Vue.component('CatUxoFormAdSubscribe', require('./forms/AdSubscribe'));

// Components
Vue.component('CatUxoHero', require('./Hero'));
Vue.component('CatUxoAdvert', require('./Advert'));
Vue.component('CatUxoCallToAction', require('./CallToAction'));
Vue.component('CatUxoCallToActionOutline', require('./CallToActionOutline'));
Vue.component('CatUxoRecentUpdates', require('./RecentUpdates'));
Vue.component('CatUxoSearchBox', require('./SearchBox'));
Vue.component('CatUxoSearchFilters', require('./SearchFilters'));

Vue.component('CatUxoTypes', require('./uxo/Types'));

Vue.component('CatUxoList', require('./uxo/List'));
Vue.component('CatUxoItem', require('./uxo/Item'));
Vue.component('CatUxoIncident', require('./uxo/Incident'));
Vue.component('CatUxoIncidents', require('./uxo/Incidents'));
Vue.component('CatUxoTerroristGroups', require('./uxo/TerroristGroups'));
Vue.component('CatUxoTerroristGroup', require('./uxo/TerroristGroup'));

Vue.component('CatUxoPagination', require('./shared/Pagination'));
Vue.component('CatUxoModal', require('./shared/Modal'));

Vue.component('CatUxoAssociatedHazards', require('./AssociatedHazards'));
Vue.component('CatUxoUploader', require('./Uploader'));
Vue.component('CatUxoSupporterContributions', require('./SupporterContributions'));
Vue.component('CatUxoSubscriptions', require('./Subscriptions'));

Vue.component('CatUxoAdvertisement', require("./Advertisement"));
Vue.component('CatUxoLinearAds', require("./shared/LinearAds"));
Vue.component('CatUxoStackedAds', require("./shared/StackedAds"));
Vue.component('CatUxoAdTemplate', require("./shared/AdTemplate"));


Vue.component('CatUxoProfileChangePassword', require("./pages/settings/ChangePassword.vue"));



// WEBPACK FOOTER //
// ./resources/js/components/bootstrap.js